// extracted by mini-css-extract-plugin
export default {"toggleBtn":"darkmode_toggleBtn__Mc+3f","label":"darkmode_label__Ksuxu"};